




















import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from 'vue-property-decorator'
import {ChartCard} from "wings-ui-components";


@Component({components: {ChartCard}})
export default class PushSubscriberCharts extends Vue {
  @Prop() readonly value: any[] | undefined;

  get lineChartData(){
    let labels: string[] = [];
    let summary: number[] = [];
    let data = {
      labels: labels,
      summary: summary,
    };
    if (!this.value) return data;
    if (!this.value.length) return data;

    this.value.forEach(row => {
      let dateStr = row.date;
      data.labels.push(dateStr);
      data.summary.push(row.android_count + row.ios_count);
    });
    return data;
  }
}
